<script>
import LABELS from '@/constants/labels'
import QuestionAndAnswer from '@/components/question-and-answer'
import { faqList } from '@/constants/data'

export default {
  components: { QuestionAndAnswer },
  data: () => ({
    listQA: faqList,
  }),
  computed: {
    mappingLabels() {
      return LABELS
    },
  },
  methods: {
    customScroll() {
      let allPage = document.getElementsByClassName('all-page')[0]
      if (!allPage.classList.contains('all-page-scroll')) {
        let el = document.getElementsByClassName('fqa_page')[0]
        el.classList.add('h-100vh')
      }
      let header = document.getElementsByClassName('header')[0]
      header.scrollIntoView()
    },
  },
  mounted() {
    this.customScroll()
  },
}
</script>

<template>
  <div>
    <s-header>{{ mappingLabels.FAQlink }}</s-header>
    <div class="fqa_page">
      <div class="fqa_page_list">
        <template v-for="item of listQA">
          <question-and-answer :key="item.numberQuestion" :qa="item" />
        </template>
      </div>
      <div class="fqa_page_notice" v-html="mappingLabels.fqaNotice"></div>
      <div class="fqa_page_button-group">
        <router-link
          class="s-button white-blue-btn mt-3"
          :to="{ name: 'home' }"
          :title="mappingLabels.backText"
          >{{ mappingLabels.backText }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'faq.scss';
</style>
